import type { WinStreakConfig } from './types';
import { winStreakConfigs } from './winStreakConfigs';
import type { WinStreakDependencies } from './WinStreakController';

export function findActiveWinStreakConfig(dependencies: WinStreakDependencies): WinStreakConfig | null {
  const { isConditionMet, observable } = dependencies;

  if (observable.getValue().winStreakActiveEvent) return null;
  return winStreakConfigs.find((config) => config.conditions.every((condition) => isConditionMet(condition))) ?? null;
}
